import React from "react";
import Accordion from "../common/Accordion";
import Button from "../common/Button";
import { formatCurrency } from "../../config/siteConfig";

const FilterPanel = ({ categories, selectedCategories, onCategory, price, onPrice, maxAvailablePrice, tags, selectedTags, onTag, onClear, onApply, mobile = false }) => (
  <aside className={`filter-panel ${mobile ? "filter-panel--mobile" : ""}`} aria-label="Product filters">
    <header><h2>Filter pantry</h2><button type="button" onClick={onClear}>Clear all</button></header>
    <Accordion title="Category" defaultOpen>
      <div className="filter-panel__options">
        {categories.map((category) => (
          <label key={category.slug}>
            <input type="checkbox" checked={selectedCategories.includes(category.slug)} onChange={() => onCategory(category.slug)} />
            <span>{category.name}</span><small>{category.count}</small>
          </label>
        ))}
      </div>
    </Accordion>
    <Accordion title="Price" defaultOpen>
      <label className="filter-panel__range">
        <span>Up to {formatCurrency(price, { maximumFractionDigits: 0 })}</span>
        <input type="range" min="45" max={maxAvailablePrice} step="1" value={price} onChange={(event) => onPrice(Number(event.target.value))} />
      </label>
    </Accordion>
    <Accordion title="Flavor & use">
      <div className="filter-panel__chips">
        {tags.map((tag) => (
          <button type="button" className={selectedTags.includes(tag) ? "is-active" : ""} onClick={() => onTag(tag)} key={tag}>{tag.replace(/-/g, " ")}</button>
        ))}
      </div>
    </Accordion>
    {mobile && <Button fullWidth type="button" onClick={onApply}>Show results</Button>}
  </aside>
);

export default FilterPanel;
